import React, { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import VoiceCard from "./components/VoiceCard";
import Touring from "./components/Touring";
import Wicked from "./components/Wicked";
import Studio from "./components/Studio";
import Repertoire from "./components/Repertoire";
import Skills from "./components/Skills";
import Media from "./components/Media";
import Booking from "./components/Booking";
import Footer from "./components/Footer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-white p-8">
          <div className="text-center max-w-md">
            <p className="font-mono text-xs tracking-[0.3em] text-hpink mb-4">SOMETHING WENT WRONG</p>
            <p className="text-hmut text-sm">{String(this.state.error.message || this.state.error)}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const SECTIONS = (
  <>
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <VoiceCard />
      <Touring />
      <Wicked />
      <Studio />
      <Repertoire />
      <Skills />
      <Media />
      <Booking />
    </main>
    <Footer />
  </>
);

export default function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a) {
        const href = a.getAttribute("href");
        if (href && href.length > 1) {
          e.preventDefault();
          lenis.scrollTo(href, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain relative bg-ink text-white antialiased">
      <ErrorBoundary>{SECTIONS}</ErrorBoundary>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}
